import { api } from '@/api'
import type {
  CancelInteractionPayload,
  CompleteInteractionPayload,
  CreateInteractionPayload,
  Id,
  Interaction,
  InteractionListParams,
  Page,
  ReplanInteractionPayload,
  UpdateInteractionPayload,
} from '@/api/types'

export const interactionsApi = {
  list: (params: InteractionListParams = {}) =>
    api.get<Page<Interaction>>('/interactions', { query: { ...params } }),

  listForClient: (idOrCode: string, params: Omit<InteractionListParams, 'client_id'> = {}) =>
    api.get<Page<Interaction>>(`/clients/${encodeURIComponent(idOrCode)}/interactions`, {
      query: { ...params },
    }),

  get: (id: Id) => api.get<Interaction>(`/interactions/${encodeURIComponent(id)}`),

  create: (idOrCode: string, payload: CreateInteractionPayload) =>
    api.post<Interaction>(`/clients/${encodeURIComponent(idOrCode)}/interactions`, payload),

  update: (id: Id, payload: UpdateInteractionPayload) =>
    api.patch<Interaction>(`/interactions/${encodeURIComponent(id)}`, payload),

  remove: async (id: Id): Promise<void> => {
    await api.delete(`/interactions/${encodeURIComponent(id)}`)
  },

  undelete: (id: Id) => api.post<Interaction>(`/interactions/${encodeURIComponent(id)}/restore`),

  /** Lot 10 : `planned` → `done`. */
  complete: (id: Id, payload: CompleteInteractionPayload = {}) =>
    api.post<Interaction>(`/interactions/${encodeURIComponent(id)}/complete`, payload),

  /** Lot 10 : `planned` → `cancelled`. */
  cancel: (id: Id, payload: CancelInteractionPayload = {}) =>
    api.post<Interaction>(`/interactions/${encodeURIComponent(id)}/cancel`, payload),

  /** Lot 10 : `cancelled` → `planned`. */
  replan: (id: Id, payload: ReplanInteractionPayload) =>
    api.post<Interaction>(`/interactions/${encodeURIComponent(id)}/replan`, payload),
}
